import React from 'react';
import type { EventdetectorDefinition } from '@ais-ui/api-spec/eventdetector';
import { EditAreaDetectorDialog } from '../Area/EditAreaDetector';
import { EditCableDetectorDialog } from '../Cable/EditCableDetector';
import { EditLineDetectorDialog } from '../Line/EditLineDetector';

interface EditDetectorDialogProps {
  detector: EventdetectorDefinition;
  showDialog: boolean;
  setShowDialog: (showDialog: boolean) => void;
}

export const EditDetectorDialog = ({
  detector,
  showDialog,
  setShowDialog,
}: EditDetectorDialogProps) => {
  switch (detector.type) {
    case 'area':
      return (
        <EditAreaDetectorDialog
          detector={detector}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      );
    case 'cable':
      return (
        <EditCableDetectorDialog
          detector={detector}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      );
    case 'line':
      return (
        <EditLineDetectorDialog
          detector={detector}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      );
    default:
      return null;
  }
};
